import * as actions from './Actions.js';

import Component from 'react-pure-render/component';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

export class NotaExplicativaModal extends Component {
  static propTypes = {
    modalId: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    nota: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired
  };

  render() {
    const { show, onClose, nota, modalId } = this.props;

    if (show) {
      return (
        <div className="panel">
          <div className="panel-body">
            <div className="modal open">
              <div
                className="container"
                style={{ marginTop: '54px', textAlign: 'center' }}
              >
                <div
                  style={{
                    position: 'relative',
                    display: 'inline-block',
                    maxWidth: '100%'
                  }}
                >
                  <span
                    className="close close-modal"
                    style={{ position: 'absolute', top: 0, right: 0 }}
                    onClick={() => onClose(modalId)}
                  ></span>
                  <Panel
                    expansible={false}
                    containerStyle={{
                      width: 'fit-content',
                      maxWidth: '100%',
                      margin: '0 auto'
                    }}
                    bodyStyle={{ paddingTop: '40px' }}
                  >
                    <div key={nota.get('id')}>
                      <div>
                        {nota.get('imgPath') && (
                          <div className="form-group">
                            <div
                              style={{
                                width: 'fit-content',
                                maxWidth: '100%',
                                justifyContent: 'center',
                                display: 'flex'
                              }}
                            >
                              <a
                                href={nota.get('link') ? nota.get('link') : '#'}
                                target={nota.get('link') ? '_blank' : ''}
                                style={{
                                  cursor: nota.get('link')
                                    ? 'pointer'
                                    : 'default',
                                  display: 'block'
                                }}
                              >
                                <img
                                  src={nota.get('imgPath')}
                                  style={{ maxWidth: '100%', height: 'auto' }}
                                />
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Panel>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}
function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, actions)(NotaExplicativaModal);
